import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".splide.logo-slider")) return;

  let logoSlider = new Splide(".splide.logo-slider", {
    type: "loop",
    arrows: false,
    pagination: false,
    perPage: 2,
    autoWidth: true,
    gap: "6rem",
    autoScroll: {
      speed: 0.75, // lower = slower, smooth scroll
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    mediaQuery: "min",
    breakpoints: {
      992: {
        perPage: 6,
      },
      768: {
        perPage: 4,
      },
      576: {
        perPage: 3,
      },
    },
    extensions: { AutoScroll },
  });

  logoSlider.mount({ AutoScroll });
});
